<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M4 6l4 4 4-4" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'ChevronDownIcon' });
</script>
